export const TOUR_TICKET_LIST_ACTION = "TOUR_TICKET_LIST_ACTION";
export const TOUR_TICKET_LIST_SUCCESS = "TOUR_TICKET_LIST_SUCCESS";

export const TOUR_TICKET_CREATE_ACTION = "TOUR_TICKET_CREATE_ACTION";
export const TOUR_TICKET_DELETE_ACTION = "TOUR_TICKET_DELETE_ACTION";
export const TOUR_TICKET_GET_UPDATE_ACTION = "TOUR_TICKET_GET_UPDATE_ACTION";
export const TOUR_TICKET_GET_UPDATE_SUCCESS = "TOUR_TICKET_GET_UPDATE_SUCCESS";
export const TOUR_TICKET_UPDATE_ACTION = "TOUR_TICKET_UPDATE_ACTION";
export const TOUR_TICKET_UPDATE_SUCCESS = "TOUR_TICKET_UPDATE_SUCCESS";

export const TOUR_TICKET_CREATE_TRANSLATE_ACTION = "TOUR_TICKET_CREATE_TRANSLATE_ACTION";
export const TOUR_TICKET_CREATE_TRANSLATE_SUCCESS = "TOUR_TICKET_CREATE_TRANSLATE_SUCCESS";

export const TOUR_TICKET_UPDATE_TRANSLATE_ACTION = "TOUR_TICKET_UPDATE_TRANSLATE_ACTION";
export const TOUR_TICKET_UPDATE_TRANSLATE_SUCCESS = "TOUR_TICKET_UPDATE_TRANSLATE_SUCCESS";

export const TOUR_TICKET_DELETE_TRANSLATE_ACTION = "TOUR_TICKET_DELETE_TRANSLATE_ACTION";
export const TOUR_TICKET_DELETE_TRANSLATE_SUCCESS = "TOUR_TICKET_DELETE_TRANSLATE_SUCCESS";

export const TOUR_TICKET_RESET = "TOUR_TICKET_RESET";
export const TOUR_TICKET_FAIL = "TOUR_TICKET_FAIL";

export const TOUR_TICKET_CHECK_ACTION = "TOUR_TICKET_CHECK_ACTION";
export const TOUR_TICKET_CHECK_SUCCESS = "TOUR_TICKET_CHECK_SUCCESS";
export const TOUR_TICKET_CHECK_FAIL = "TOUR_TICKET_CHECK_FAIL";

export const TOUR_TICKET_LIST_ALL_ACTION = "TOUR_TICKET_LIST_ALL_ACTION";
export const TOUR_TICKET_LIST_ALL_SUCCESS = "TOUR_TICKET_LIST_ALL_SUCCESS";

export const TOUR_TICKET_LIST_ALL_BY_ID_ACTION = "TOUR_TICKET_LIST_ALL_BY_ID_ACTION";
export const TOUR_TICKET_LIST_ALL_BY_ID_SUCCESS = "TOUR_TICKET_LIST_ALL_BY_ID_SUCCESS";
export const TOUR_TICKET_LIST_ALL_BY_ID_FAIL = "TOUR_TICKET_LIST_ALL_BY_ID_FAIL";
